// ============================================================
// scrollHidden.js — .js-scroll-hidden 要素のフェード制御
//
// 100lvh スクロールで非表示、戻ると再表示
// ============================================================

export function scrollHidden() {
  const els = document.querySelectorAll(".js-scroll-hidden");
  if (!els.length) return;

  const threshold = window.innerHeight; // 100lvh 相当

  function update() {
    const scrollY = window.scrollY;
    const hidden = scrollY >= threshold;
    els.forEach((el) => {
      el.classList.toggle("_is-hidden", hidden);
    });
  }

  window.addEventListener("scroll", update, { passive: true });
  update();
}
